import { PathTypedColDef } from './types';

export function centBasedCurrencyColumnByField(
  args: Omit<PathTypedColDef, 'type'>
): PathTypedColDef {
  return { ...args, type: 'centBasedCurrency' };
}

export function paymentStatusColumnByField(
  args: Omit<PathTypedColDef, 'cellRenderer'>
): PathTypedColDef {
  return { ...args, cellRenderer: 'statusCell' };
}
